module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jTQc5"))).then(() => parcelRequire('1iHdE'));